module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-header": "",
      "no-footer": ""
    }
  }, [(_vm.game) ? _c('v-list', {
    staticClass: "my-list",
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.log), function(event, i) {
    return _c('event-preview', {
      key: _vm.log.length - i,
      attrs: {
        "event": event
      },
      on: {
        "details": function($event) {
          _vm.onDetails(event)
        }
      }
    })
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4ef3b4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/routes/LogView.vue
// module id = 356
// module chunks = 0